import React from 'react';
import { Redirect } from 'react-router-dom';
import HomeView from './views/Home/loadable';
import Error401 from './views/Error401/loadable';
import Error404 from './views/Error404/loadable';
import Error500 from './views/Error500/loadable';
import Login, { ForgotPassword, ResetPassword } from './views/Login/loadable';
import Register from './views/Register/loadable';
import Simulator from './views/Simulator/loadable';
import { DeviceDetails, Devices, DeviceSetting, OwnedDevices } from './views/Devices/loadable';
import { HealthMonitoring, LocationMonitoring } from './views/Monitoring/loadable';
import { UserDetails, UserListing } from './views/Users/loadable';
import ErrorLayout from './layouts/Error';
import AuthLayout from './layouts/Auth';
import GuestLayout from './layouts/GuestLayout';
import LoginRequired from './layouts/LoginRequired';
import Overview from './views/Overview/loadable';
import { CompaniesListing, CompanyDetails } from './views/Companies/loadable';
import { BranchDetails, BranchesListing } from './views/Branches/loadable';
import SalesDashboard from './views/SalesDashboard/loadable';
import { AllNotifications, OwnNotifications } from './views/Notifications/loadable';
import TelegramRegister from './views/TelegramRegister/loadable';
import { TasksDashboardLoadable, TasksListLoadable } from './views/Tasks/loadable';
import {
  BLTAlertLogsViewLoadable,
  BLTBeaconLoadable,
  BLTGatewayLoadable,
  BLTLiveInteractionLoadable,
  BLTLiveInteractionRoomViewLoadable,
} from './views/BLTGateway/loadable';
import OnboardNewDevice, { OnboardingFormRevamped } from './views/OnboardNewDevice/loadable';

const UnderConstruction = props => {
  const {
    location: { pathname },
  } = props;
  return `${(pathname || '').replace('/', '').toUpperCase()} is Under Construction`;
};

const routes = [
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: Login,
      },
      {
        path: '/auth/register',
        exact: true,
        component: Register,
      },
      {
        path: '/auth/forgotPassword',
        exact: true,
        component: ForgotPassword,
      },
      {
        path: '/auth/resetPassword',
        exact: true,
        component: ResetPassword,
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: Error401,
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: Error404,
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: Error500,
        props: {
          isHeaderVisible: false,
          isFooterVisible: false,
        },
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: '/user',
    component: LoginRequired,
    routes: [
      {
        path: '/user/',
        exact: true,
        component: HomeView,
      },
      {
        path: '/user/overview',
        exact: true,
        component: Overview,
      },
      {
        path: '/user/home',
        component: Overview,
      },
      {
        path: '/user/dashboard',
        component: UnderConstruction,
      },
      {
        path: '/user/monitoring',
        component: HealthMonitoring,
      },
      {
        path: '/user/location',
        component: LocationMonitoring,
      },
      {
        path: '/user/detail/:uuid',
        component: UserDetails,
      },
      {
        path: '/user/device/:uuid',
        component: DeviceDetails,
      },
      {
        path: '/user/devices',
        exact: true,
        component: OwnedDevices,
      },
      {
        path: '/user/telegram',
        exact: true,
        component: TelegramRegister
      },
      {
        path: '/user/notifications',
        exact: true,
        component: OwnNotifications,
      },
      {
        path: '/user/devices/:filterKey',
        component: OwnedDevices,
      },
      {
        path: '/user/settings',
        component: DeviceSetting
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: '/admin',
    component: LoginRequired,
    routes: [
      {
        path: '/admin/simulator',
        component: Simulator,
      },
      {
        path: '/admin/devices',
        exact: true,
        component: Devices,
      },
      {
        path: '/admin/devices/:filterKey',
        component: Devices,
      },
      {
        path: '/admin/users',
        exact: true,
        component: UserListing,
      },
      {
        path: '/admin/users/:filterKey',
        component: UserListing,
      },
      {
        path: '/admin/companies',
        exact: true,
        component: CompaniesListing,
      },
      {
        path: '/admin/company/:uuid',
        component: CompanyDetails,
      },
      {
        path: '/admin/branches',
        exact: true,
        component: BranchesListing,
      },
      {
        path: '/admin/branch/:uuid',
        component: BranchDetails,
      },
      {
        path: '/admin/dashboard',
        exact: true,
        component: SalesDashboard,
      },
      {
        path: '/admin/notifications',
        exact: true,
        component: AllNotifications,
      },
      {
        path: '/admin/task/dashboard',
        exact: true,
        component: TasksDashboardLoadable,
      },
      {
        path: '/admin/task/list',
        exact: true,
        component: TasksListLoadable,
      },
      {
        path: '/admin/gateway',
        exact: true,
        component: BLTGatewayLoadable,
      },
      {
        path: '/admin/beacons',
        exact: true,
        component: BLTBeaconLoadable,
      },
      {
        path: '/admin/gateway/interactions',
        exact: true,
        component: BLTLiveInteractionLoadable
      },
      {
        path: '/admin/gateway/roomViewInteractions',
        exact: true,
        component: BLTLiveInteractionRoomViewLoadable
      },
      {
        path: '/admin/alertlogs',
        exact: true,
        component: BLTAlertLogsViewLoadable
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: '*',
    component: GuestLayout,
    routes: [
      {
        path: '/',
        exact: true,
        component: HomeView,
      },
      {
        path: '/ndr/onboard/device',
        exact: true,
        redirect: false,
        component: OnboardNewDevice
      },
      {
        path: '/ndr/onboard/new',
        exact: true,
        redirect: false,
        component: OnboardingFormRevamped
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
];

export default routes;
